import { queryBot2 } from 'boot/axios';
import unescapeSql from 'src/model/db/utils';
import { calcDate, calcEmpty, loadProjectByField } from 'src/model/projects';

export async function saveProjectLikes (project) {
    await queryBot2('saveProjectLikes', { likes: JSON.stringify(project.likes), id: project.id }).then(() => {
        console.log('upd');
    });
}

export async function saveProjectItem (item) {
    const { id, key, value } = item;
    if (!key || !id) {
        return;
    }
    // values of key: author, customer, portfolio, status, is_open, created_at, title, description, likes, color, icon, community, location, url, notes
    await queryBot2(`saveProjectItem-${key}`, { value, id }).then((r) => {
        console.log('upd', r);
    });
}

export async function saveProjectUpdate (project) {
    if (!project.id) {
        return undefined;
    }
    return queryBot2('saveProjectUpdate', {
        customer: calcEmpty(project.customer) ? '' : project.customer,
        portfolio: calcEmpty(project.portfolio) ? '0' : project.portfolio,
        status: calcEmpty(project.status) ? '0' : project.status,
        is_open: calcEmpty(project.is_open) ? '0' : project.is_open,
        title: calcEmpty(project.title) ? '' : unescapeSql(project.title),
        description: calcEmpty(project.description) ? '' : unescapeSql(project.description),
        color: calcEmpty(project.color) ? '' : project.color,
        icon: calcEmpty(project.icon) ? '' : project.icon,
        community: calcEmpty(project.community) ? '' : project.community,
        location: calcEmpty(project.location) ? '' : project.location,
        url: calcEmpty(project.url) ? '' : project.url,
        notes: calcEmpty(project.notes) ? '' : unescapeSql(project.notes),
        id: project.id,
    }).then(() => true);
}

export async function saveProjectInsert (userId, portfolioId) {
    const dt = calcDate();
    return queryBot2('saveProjectInsert', { userId, portfolioId, dt }).then(() => loadProjectByField('author', userId));
}

export default saveProjectLikes;
